export class ServiceBase {
    title: string = 'temp';
    contents: {
        subTitle: string,
        textcontents: string[],
        imagePath: string
    }[] = [];

}



// WEBPACK FOOTER //
// C:/Users/Yi-Yu/Documents/Actual Documents/Katiso/katiso/src/app/components/services/services-base/service.base.class.ts